import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertaService } from '@shared/modules/alerta/alerta.service';
import { StatusProcessamento, StatusProcessamentoMessage } from '@utils/interfaces/status-processamento.interface';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(public alertaService: AlertaService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.url.includes('apl-api-obc/servicoscanal/configuracoes')) {
          return;
        } else if (error.status === 400 || error.status === 401 || (error.status >= 500 && error.status <= 550)) {
          this.alertaService.show(
            'Atenção',
            'Ocorreu um erro na outra instituição. Por favor tente novamente mais tarde.'
          );
        }

        return throwError(error);
      })
    );
  }
}
